/** @typedef {Set<number>} State */
/** @typedef {import("../../../adapters/weekly-report/get-weekly-report-adapter").TableData} TableData */
/** @typedef {import('../hooks').Filters} Filters */

import { isCheckedPosition } from '../utils/isChecked';
import { isInDateRange } from '../utils/date';

/** @param {State} state @param {{id: string, dailyReportID: number}} payload */
export const handleDay = (state, payload) => {
  const { dailyReportID } = payload;

  const newSet = new Set(state);

  if (newSet.has(dailyReportID)) {
    newSet.delete(dailyReportID);

    return newSet;
  }
  newSet.add(dailyReportID);

  return newSet;
};

/** @param {State} state @param {{id: string, tableData: TableData, filters: Filters}} payload */
export const handleLine = (state, payload) => {
  const { id, tableData, filters } = payload;

  const { fechaDesde, fechaHasta } = filters;

  // Split the ID into group and line. E.g., 0-0
  const [groupID, lineID] = id.split('-');

  const { weeklyReport } = tableData[+groupID].group[+lineID];

  const isChecked = isCheckedPosition({ daysIDsToApproveOrReject: state, weeklyReport, filters });

  const newState = structuredClone(state);

  // Access the group and position/line of the table data array
  // to retrieve all daily IDs.
  // weeklyReport -> (string | Date)[]
  /** @type {number[]} */
  const weekReportIDs = tableData[+groupID].group[+lineID].weeklyReport.reduce((arr, current) => {
    const isDateInRange = isInDateRange(fechaDesde, fechaHasta, current.fecha);

    if (typeof current === 'object' && current.habilitaCheck && isDateInRange) {
      arr.push(current.idParteDiario);
    }

    return arr;
  }, []);

  weekReportIDs.forEach((i) => {
    if (isChecked) {
      newState.delete(i);
    } else {
      newState.add(i);
    }
  });

  return newState;
};

/** @param {State} state @param {{id: number, tableData: TableData, filters: Filters} payload */
export const handleGroup = (state, payload) => {
  const { id: groupID, tableData, filters } = payload;

  const { fechaDesde, fechaHasta } = filters;

  /** @type {number[]} */
  const availableGroupIds = tableData[+groupID].group.reduce((acc, positionLine) => {
    positionLine.weeklyReport.forEach((dayReport) => {
      const isDateInRange = isInDateRange(fechaDesde, fechaHasta, dayReport.fecha);

      if (typeof dayReport === 'object' && dayReport.habilitaCheck && isDateInRange) {
        acc.push(dayReport.idParteDiario);
      }
    });

    return acc;
  }, []);

  const isGroupChecked = availableGroupIds.every((id) => state.has(id));

  const newState = structuredClone(state);

  availableGroupIds.forEach((i) => {
    if (isGroupChecked) {
      newState.delete(i);
    } else {
      newState.add(i);
    }
  });

  return newState;
};

export const handleSetInitialState = (_, payload) => {
  const { initialData } = payload;

  return new Set(initialData);
};
